import { useMemo } from 'react';
export const useIsSelected = ({ value, selectedValues }) => {
    const isSelected = useMemo(() => selectedValues?.some((selected) => selected == value) ?? false, [selectedValues, value]);
    return isSelected;
};
